import { Modal } from "react-bootstrap";
import ThemedModal from "../../../utilities/ThemedModal";
import Button from "../../../buttons";
import { ThemedSpan } from "../../../utilities";

const AccountVulnerabilityStatusModal = ({
    backdrop = 'static',
    cancel,
    centered = true,
    dialogId,
    dismiss,
    masterAccountId,
    proceed,
    show,
    size = "xl",
    ...rest
}) => {
    const onClose = () => proceed(false);
    const onProceed = () => proceed(true);

    return (
        <Modal backdrop={backdrop} centered={centered} size={size} show={show} onHide={onClose} {...rest}>
            <ThemedModal.Header closeButton>
                <Modal.Title>Remove Vulnerable Client Status?</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                <ThemedSpan>This account no longer has any active client vulnerabilities. Do you wish to remove the vulnerable client status from this account?</ThemedSpan>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={onProceed}>Confirm</Button>
                <Button variant="light" onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AccountVulnerabilityStatusModal;